exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-contact-contact-remark__inscription {\n  margin-top: 1.07rem;\n}\n.lxm-contact-contact-remark__inscription-update {\n  margin-left: 1.07rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/Contact/Contact/src/components/Main/Contact/Contact/Remark.vue","/./src/components/Main/Contact/Contact/Remark.vue"],"names":[],"mappings":";AA4BA;EACE,oBAAA;CC3BD;AD4BD;EACE,qBAAA;CC1BD","file":"Remark.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../../styles/variables.styl'\n.lxm-contact-contact-remark__inscription\n  margin-top: spacing\n.lxm-contact-contact-remark__inscription-update\n  margin-left: spacing\n",".lxm-contact-contact-remark__inscription {\n  margin-top: 1.07rem;\n}\n.lxm-contact-contact-remark__inscription-update {\n  margin-left: 1.07rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-be6b4b7c!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Contact/Contact/Remark.vue
// module id = 664
// module chunks = 0